import React from 'react';
import { useCurrency } from '../hooks/useCurrency';

interface PriceDisplayProps {
  basePrice: number;
  className?: string;
  loading?: boolean;
}

const PriceDisplay: React.FC<PriceDisplayProps> = ({ 
  basePrice, 
  className = '', 
  loading = false 
}) => {
  const { pricing, isLoading, calculatePrice } = useCurrency();

  if (isLoading || loading) {
    return (
      <span className={`price-display loading ${className}`}>
        <span style={{ opacity: 0.6 }}>...</span>
      </span>
    );
  }

  const displayPrice = calculatePrice(basePrice);

  return (
    <span className={`price-display ${className}`} style={{ 
      display: 'inline-flex', 
      alignItems: 'center', 
      gap: '6px',
      flexWrap: 'wrap',
      justifyContent: 'center'
    }}>
      {pricing?.flag && (
        <span style={{ fontSize: '1.2em', lineHeight: 1 }}>
          {pricing.flag}
        </span>
      )}
      <span style={{ whiteSpace: 'nowrap' }}>
        {displayPrice}
      </span>
    </span>
  );
};

export default PriceDisplay;